import {
    CREATEAYURVEDICTYPE,
    GETAYURVEDICTYPE,
    UPDATEAYURVEDICTYPE,
    DELETEAYURVEDICTYPE,
    CREATEAYURVEDICHEAD,
    GETAYURVEDICHEAD,
    UPDATEAYURVEDICHEAD,
    DELETEAYURVEDICHEAD,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEAYURVEDICTYPE:
            return {
                ...state,
                dietCharttypeSaveStatus: action.payload.success,
            }
        case GETAYURVEDICTYPE:
                return {
                        ...state,
                        dietCharttypeList: action.payload.data,
                        }
        case UPDATEAYURVEDICTYPE:
                return {
                        ...state,
                        dietCharttypeUpdateStatus: action.payload.success,
                        }   

        case DELETEAYURVEDICTYPE:
                 return {
                     ...state,
                     dietCharttypeDeleteStatus: action.payload.success,
                        } 
        case CREATEAYURVEDICHEAD:
                return {
                        ...state,
                        dietChartheadSaveStatus: action.payload.success,
                        }
        case GETAYURVEDICHEAD:
                 return {
                        ...state,
                        dietChartheadList: action.payload.data,
                        }
        case UPDATEAYURVEDICHEAD:
                return {
                        ...state,
                        dietChartheadUpdateStatus: action.payload.success,
                        }   
                
        case DELETEAYURVEDICHEAD:
                    return {
                            ...state,
                            dietChartheadDeleteStatus: action.payload.success,
                            } 
        default:
                return state
                      }
                 }